import React from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import theme from 'config/theme';

const Tooltip = ({
  children,
  title,
  placement = 'top',
  arrow = true,
  ...rest
}) => {
  const titleContent =
    typeof title === 'string' ? (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // eslint-disable-line react/no-danger
          __html: title,
        }}
      />
    ) : (
      title
    );

  return (
    <MuiTooltip
      arrow={arrow}
      placement={placement}
      title={titleContent}
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: theme.palette.white.paper,
            color: theme.palette.black.main,
            boxShadow: theme.customShadows.darkTooltipShadow,
            '& .MuiTooltip-arrow': {
              color: theme.palette.white.paper,
            },
          },
        },
      }}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
